(function () {
  const KEY = 'rs_compare_handles';
  const LIMIT = 5;


  //************ */

      const META_KEY = 'rs_compare_meta';

      const getMeta = () => {
      try { return JSON.parse(localStorage.getItem(META_KEY) || '{}'); }
      catch (e) { return {}; }
      };

      const setMeta = (obj) => {
      localStorage.setItem(META_KEY, JSON.stringify(obj));
      };


  //************* */

  /* storage */
  const get = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  };
  const set = (arr) => localStorage.setItem(KEY, JSON.stringify(Array.from(new Set(arr))));

  /* dom */
  const $bar   = document.getElementById('rs-compare-bar');
  const $count = document.getElementById('rs-compare-count');
  const $btn   = document.getElementById('rs-compare-btn');
  const $clear = document.getElementById('rs-compare-clear');

  /* merge ?items= into LS (cap to LIMIT) */
  function mergeFromQueryIfPresent() {
    const params = new URLSearchParams(location.search);
    const fromQuery = (params.get('items') || '')
      .split(',').map(s => s.trim()).filter(Boolean);
    if (!fromQuery.length) return;

    const merged = Array.from(new Set([...(get() || []), ...fromQuery])).slice(0, LIMIT);
    set(merged);
  }

  function updateUI() {
    const arr = get();
    if ($count) $count.textContent = arr.length;
    if ($bar)   $bar.classList.toggle('hidden', arr.length === 0);

    document.querySelectorAll('.rs-compare-input[data-handle]').forEach(cb => {
      const h = cb.getAttribute('data-handle');
      cb.checked = !!h && arr.includes(h);
    });
  }




  function getJudgeMeData(card) {
  // Judge.me uses jdgm-prev-badge on collection pages
  const badge =
  card.querySelector('.jdgm-prev-badge') ||
  card.querySelector('.jdgm-preview-badge');

  if (!badge) {
  return { rating: 0, count: 0, badge: null };
  }

  const rating =
  parseFloat(badge.getAttribute('data-average-rating')) ||
  parseFloat(
  badge.querySelector('.jdgm-prev-badge__stars')?.getAttribute('data-score')
  ) ||
  0;

  const count =
  parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;

  return { rating, count, badge };
  }

  document.addEventListener('change', function (e) {
    localStorage.setItem('rs_compare_user_selected', '1');
    const cb = e.target.closest('.rs-compare-input');
    if (!cb) return;
    const handle = cb.getAttribute('data-handle');
    if (!handle) return;



    const card = cb.closest('li') || cb.closest('.grid__item') || document;



    // 👇 read Judge.me data
  const { rating, count, badge } = getJudgeMeData(card);

const compareMeta = getMeta();
compareMeta[handle] = compareMeta[handle] || {};

// save immediately if data exists
compareMeta[handle].jdgmRating = rating;
compareMeta[handle].jdgmCount  = count;
setMeta(compareMeta);

// 🔁 If Judge.me hasn't injected yet, watch it
if (badge && (!rating || !count)) {
  const observer = new MutationObserver(() => {
    const r =
      parseFloat(badge.getAttribute('data-average-rating')) ||
      parseFloat(
        badge.querySelector('.jdgm-prev-badge__stars')?.getAttribute('data-score')
      ) ||
      0;

    const c =
      parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;

    if (r || c) {
      observer.disconnect();

      const cm = getMeta();
      cm[handle] = cm[handle] || {};
      cm[handle].jdgmRating = r;
      cm[handle].jdgmCount  = c;
      setMeta(cm);
    }
  });

  observer.observe(badge, {
    attributes: true,
    subtree: true,
    attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'data-score']
  });
}



    const brandName =
    card.querySelector('.rs-brand-hidden')?.value?.trim() || '';

    let brandUrl =
    card.querySelector('.rs-brand-url-hidden')?.value?.trim() || '';

    // Ensure URL starts with /
    if (brandUrl && !brandUrl.startsWith('/')) {
    brandUrl = '/' + brandUrl;
    }





    let arr = get();

    // If user is trying to add a new one and we’re at LIMIT, block it
    if (cb.checked && !arr.includes(handle) && arr.length >= LIMIT) {
      cb.checked = false; // revert the UI
      // Replace alert with your toast if you have one
     // alert(`You can compare up to ${LIMIT} products.`);

    //  #limit-cmp-modal.add class show
    document.getElementById('limit-compare-modal')?.classList.add('show');
      return;
    }

    // Toggle in storage
  
// if (cb.checked) {
//   arr.push(handle);
//   set(arr);

//   // ✅ save brand meta
//   const meta = getMeta();
//   meta[handle] = {
//     brandName,
//     brandUrl
//   };
//   setMeta(meta);

// } else {
//   set(arr.filter(h => h !== handle));

//   // optional cleanup
//   const meta = getMeta();
//   delete meta[handle];
//   setMeta(meta);
// }

if (cb.checked) {
  arr.push(handle);
  set(arr);

  const meta = getMeta();
  meta[handle] = meta[handle] || {};

  meta[handle].brandName   = brandName;
  meta[handle].brandUrl    = brandUrl;
  meta[handle].jdgmRating  = rating;
  meta[handle].jdgmCount   = count;

  setMeta(meta);
}
else {
  set(arr.filter(h => h !== handle));

  // optional cleanup
  const meta = getMeta();
  delete meta[handle];
  setMeta(meta);
}


    updateUI();
  });

  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
     NEW RULE: MINIMUM 2 PRODUCTS REQUIRED TO PROCEED
     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
  if ($btn) {
    $btn.addEventListener('click', function () {
      const arr = get();

      // NEW VALIDATION
      if (arr.length < 2) {
        // alert("Please select at least TWO products to compare.");
        const modal = document.getElementById('compare-modal');
        modal.classList.add('show');
        return; // Do not redirect
      }

      // Proceed normally
      window.location.href = '/pages/compare?items=' + encodeURIComponent(arr.join(','));
    });
  }
  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */


  if ($clear) {
    $clear.addEventListener('click', function () {
      set([]);
      updateUI();
    });
  }

  mergeFromQueryIfPresent();
  document.addEventListener('DOMContentLoaded', updateUI);
  document.addEventListener('shopify:section:load', updateUI);
  document.addEventListener('shopify:section:render', updateUI);
})();
